import React, { FC } from "react";
import { Box, Button, Typography } from "@mui/material";
import CoreButtons from "../../../components/core-components/button/CoreButtons";
import { BUTTON_COLOR, BUTTON_VARIANT } from "../../../types/coreButtonTypes";
import useTimer from "../../../hooks/useTimer";
import DeclineCorporateEventIcon from "../../../assets/svg-fc/b2b/DeclineCorporateEventIcon";
import { VendorEventResponseStatusesEnum } from "../../../types/eventTypes";
import "./detailsTabContent.scss";

interface iEventActionProp {
	firstBtntitle?: string;
	firstBtnStatus?: number;
	secondBtntitle?: string;
	secondBtnStatus?: number;
	title?: string;
	footerRequestClass?: string;
	acceptRequest?: boolean;
	expireAt?: string;
	eventRequestId?: string;
	vendorStatus?: number;
	declineButtonV2?: boolean;
	sendQuoteButton?: boolean;
	fullWidth?: boolean;
	dashboardFooterStyles?: React.CSSProperties;
	declineButtonRed?: boolean;
	firstBtnHandler?: (status: number) => void;
	btnhandler: (status: number) => void;
	customerServiceModalOpner?: () => void;
}

const Footer: FC<iEventActionProp> = ({
	firstBtntitle,
	btnhandler,
	firstBtnStatus,
	secondBtntitle,
	secondBtnStatus,
	title,
	footerRequestClass,
	acceptRequest,
	customerServiceModalOpner,
	expireAt = "",
	eventRequestId = "",
	vendorStatus,
	declineButtonV2 = false,
	sendQuoteButton = false,
	fullWidth = false,
	dashboardFooterStyles = {},
	declineButtonRed = false,
	firstBtnHandler,
}) => {
	const timeLeft = useTimer({ expireAt, eventRequestId });
	const isAIDirectRequest = vendorStatus === VendorEventResponseStatusesEnum.AssignedByAdmin;
	return (
		<Box
			className={`dashboardFooter ${footerRequestClass} ${isAIDirectRequest ? "dashboardFooter__forAIrequest" : ""}`}
			style={dashboardFooterStyles}
		>
			<Box className="text_hold" sx={{ display: fullWidth ? "none" : "block" }}>
				<Typography variant="body1" component="p">
					{title}{" "}
					{!!timeLeft && (
						<Typography
							variant="caption"
							color="error"
							sx={{
								fontSize: "inherit",
								fontWeight: "inherit"
							}}>
							{timeLeft !== "Expired" ? `(Expires in ${timeLeft})` : ""}
						</Typography>
					)}
				</Typography>
				{!acceptRequest && !isAIDirectRequest && !declineButtonV2 && !sendQuoteButton && (
					<Typography variant="body1" component="p">
						If you need more time,{" "}
						<Button
							variant="text"
							color="primary"
							sx={{
								fontWeight: 500,
								textDecoration: "underline",
							}}
							onClick={customerServiceModalOpner}
						>
							contact customer service
						</Button>
					</Typography>
				)}
			</Box>
			<Box className={`btnGroup ${fullWidth ? "btnGroup__fullWidth" : ""}`}>
				{acceptRequest ? (
					<>
						{firstBtntitle && (
							<button
								type="button"
								onClick={() => firstBtnStatus && btnhandler(firstBtnStatus)}
								className="btn_round round_outline_secondary"
							>
								<span className="icon_hold">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
									>
										<path
											d="M18.75 5.25L5.25 18.75"
											stroke="#22031F"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M18.75 18.75L5.25 5.25"
											stroke="#22031F"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</span>
							</button>
						)}
						{secondBtntitle && (
							<button
								type="button"
								onClick={() => secondBtnStatus && btnhandler(secondBtnStatus)}
								className="btn_round round_outline_primary"
							>
								<span className="icon_hold">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
									>
										<path
											d="M20.25 6.75049L9.75 17.25L4.5 12.0005"
											stroke="white"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</span>
							</button>
						)}
					</>
				) : (
					<>
						{firstBtntitle && declineButtonV2 ? (
							<CoreButtons
								buttonText={firstBtntitle}
								variant={BUTTON_VARIANT.TEXT}
								color={BUTTON_COLOR.ERROR}
								fullWidth={false}
								disabled={false}
								coreBtnPill={true}
								startIcon={<DeclineCorporateEventIcon />}
								onclick={() => {
									if (firstBtnStatus && firstBtnHandler) {
										firstBtnHandler(firstBtnStatus);
									} else {
										btnhandler(0);
									}
								}}
							/>
						) : firstBtntitle && sendQuoteButton ? (
							<CoreButtons
								buttonText={firstBtntitle}
								variant={BUTTON_VARIANT.CONTAINED}
								color={BUTTON_COLOR.PRIMARY}
								fullWidth={true}
								disabled={false}
								coreBtnPill={true}
								onclick={() => firstBtntitle && btnhandler(0)} // 0 is for dummy status
								sx={{ textTransform: "none", width: "100%" }}
							/>
						) : (
							firstBtntitle && (
								<CoreButtons
									buttonText={firstBtntitle}
									variant={BUTTON_VARIANT.OUTLINED}
									coreBtnPill={false}
									color={declineButtonRed ? BUTTON_COLOR.ERROR : BUTTON_COLOR.SECONDARY}
									onclick={() =>
										firstBtnStatus
											? firstBtnHandler
												? firstBtnHandler(firstBtnStatus)
												: btnhandler(firstBtnStatus)
											: {}
									}
									sx={{ textTransform: "none", borderRadius: "100px" }}
								/>
							)
						)}
					{secondBtntitle && (
						<CoreButtons
							buttonText={secondBtntitle}
							variant={BUTTON_VARIANT.CONTAINED}
							color={BUTTON_COLOR.PRIMARY}
							coreBtnPill={true}
							onclick={() => btnhandler(secondBtnStatus || 0)}
							sx={{ textTransform: "none" }}
						/>
					)}
					</>
				)}
			</Box>
			{acceptRequest && (
				<Typography variant="body1" component="p">
					If you need more time,{" "}
					<Button
						variant="text"
						color="primary"
						sx={{ fontWeight: 500, textDecoration: "underline" }}
						onClick={customerServiceModalOpner}
					>
						contact customer service
					</Button>
				</Typography>
			)}
		</Box>
	);
};
export default Footer;
